import React from "react";

export enum GTMEvent {
  BOOKING_FUNNEL_INIT = "booking_funnel_init",
  BOOKING_FUNNEL_ADD_TO_CART = "booking_funnel_add_to_cart",
  BOOKING_FUNNEL_BRANCH_SELECTED = "booking_funnel_branch_selected",
  BOOKING_FUNNEL_REMOVE_FROM_CART = "booking_funnel_remove_from_cart",
  BOOKING_FUNNEL_SERVICE_SELECTION = "booking_funnel_service_selection",
  BOOKING_FUNNEL_APPOINTMENT_SELECTION = "booking_funnel_appointment_selection",
  BOOKING_FUNNEL_SIGNUP_WAITLIST = 'booking_funnel_signup_waitlist',
  BOOKING_FUNNEL_APPOINTMENT_SELECTED = "booking_funnel_appointment_selected",
  BOOKING_FUNNEL_CONTACT_DETAILS = "booking_funnel_contact_details",
  BOOKING_FUNNEL_BOOKED = "booking_funnel_booked",
  BOOKING_FUNNEL_PATH_SELECTION = "booking_funnel_path_selection",
  BOOKING_FUNNEL_PATH_SELECTED = "booking_funnel_path_selected",
  BOOKING_FUNNEL_CONFIRMATION = "booking_funnel_confirmation",
  BOOKING_FUNNEL_BUNDLE_UPSELL_PRESENTED = "booking_funnel_bundle_upsell_presented",
  BOOKING_FUNNEL_BUNDLE_UPSELL_ACCEPTED = "booking_funnel_bundle_upsell_accepted",
  BOOKING_FUNNEL_BUNDLE_UPSELL_DECLINED = "booking_funnel_bundle_upsell_declined",
  BOOKING_FUNNEL_BUNDLE_UPSELL_REDEMPTION = "booking_funnel_bundle_upsell_redemption",
  BOOKING_FUNNEL_ADDON_POPUP_PRESENTED = "booking_funnel_addon_popup_presented",
  BOOKING_FUNNEL_ADDON_POPUP_CONFIRMED = "booking_funnel_addon_popup_confirmed",
  BOOKING_FUNNEL_PRACTITIONER_SELECTED = "booking_funnel_practitioner_selected",
  BOOKING_FUNNEL_PRACTITIONER_DESELECTED = "booking_funnel_practitioner_deselected",
  APPOINTMENT_MODIFICATION_PRACTITIONER_SELECTED = "appointment_modification_practitioner_selected",
  APPOINTMENT_MODIFICATION_PRACTITIONER_DESELECTED = "appointment_modification_practitioner_deselected",
  WAITLIST_SLOT_VIEWED = "waitlist_slot_viewed",
  WAITLIST_SLOT_EXPIRED = "waitlist_slot_expired",
  WAITLIST_SLOT_BOOKED = "waitlist_slot_booked",
}

interface GTMContextProps {
  sendEvent: (event: GTMEvent, data: any) => void;
}

const GTMContext = React.createContext<GTMContextProps>({
  sendEvent: (event: GTMEvent, data: any) => {},
});

export default GTMContext;
